import { call, put, select } from 'redux-saga/effects';
const {  CloudTraceService } = require('@gc-npm/gcp-services.open-telemetry');
import FrontSonda from '@gc-npm/utils.monitoring.front-sonda';
import { init as configInit } from '@/sagas/adabyron/init';

import { actions as clientActions } from '@/reducers/client';
import { actions as modulesActions } from '@/reducers/modules';
import { actions as uiActions } from '@/reducers/ui';
import { actions as cartActions } from '@/reducers/cart';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import { getR2rTypeByApi } from '@/sagas/normalizers/client';
import MobilesLinesModal from '../components/Modals/MobilesLinesModal';
import { mobileLinesModalNavigationProps } from '@/utils/mobile-lines-modal';
import { selection } from '@/sagas/adabyron/selection';
import {
  navigate2PurchaseProcess,
  sendOrder2BackOffice,
  sendRetentionPromo,
  setMinorLmPrice,
} from '@/sagas/ui';
import { isObject, isEmpty } from '@/utils/validations';
import {
  API_STATUS,
  CONECTIVIDAD_BASE_ID,
  CONECTIVIDAD_ESENCIAL,
  CONFIRMATION_STATUS,
  FREE_ZONE_ID,
  TIPOS_R2R,
  SCREEN_TYPES,
  PRODUCT_OFFERING_TYPES,
  LAYOUT_TYPES,
  BASE_R2R_UPGRADES,
} from '@/utils/constants';
import {
  getUrlParamsSelection,
  getUrlParams,
  flattenObjectToKeyValueStrings,
  parseArrayToDict,
  getTaponInfo,
} from '@/utils/index';

const filePath = '/sagas/modules.js';

const mainStore = (state) => state.main;
const clientStore = (state) => state.client;
const cartStore = (state) => state.cart;
const multibundleOldOptionsStore = (state) => state.modulos.multibundleOldOptions;
const modulosStore = (state) => state.modulos;
const uiStore = (state) => state.UI;

function* setLoadingState() {
  yield put(modulesActions.setStatusModulos(API_STATUS.LOADING));
  yield put(modulesActions.setStatusSelection(API_STATUS.LOADING));
  yield put(clientActions.setStatus(API_STATUS.LOADING));
}

export function safeParseSessionStorage(key) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    console.error(`Error parsing ${key}:`, err);
    return null;
  }
}

function* setSuccessState(data, client) {
  yield put(modulesActions.setStatusModulos(API_STATUS.OK));
  yield put(modulesActions.setStatusSelection(API_STATUS.OK));
  yield put(modulesActions.setModules(data.modulos));
  yield put(clientActions.setStatus(API_STATUS.OK));
  yield put(clientActions.setClientInfo({ ...data.client, ...client }));
  yield put(modulesActions.setTexts(data.textosLegales||null));
  yield put(cartActions.setCart(data.cart));
  if (data.notification) yield put(uiActions.setNotification(data.notification));
  if (data.callOut) yield put(uiActions.setCallOut(data.callOut));
  if (data.seo) yield put(uiActions.setSeoData(data.seo));
  if (data.deviceSlider) yield put(uiActions.setDeviceSliderData(data.deviceSlider));
}


function* reportInitError(error, data, build, frontSonda,client) {
  yield put(modulesActions.setStatusModulos(API_STATUS.KO));
  yield put(clientActions.setStatus(API_STATUS.KO));
  if (!build) {
    frontSonda.errorMessage({
      error: `Fallo en init ${data?.error} || ${JSON.stringify(error)}`,
      info: 'Fallo en servicio init',
    });
    yield put(uiActions.setTapon({
      componentContent: 'Fallo en el servicio init',
      componentProduct: error,
      ...getTaponInfo(client, error?.statusCode),
    }));
  }
}

function* handleDirectToBuyProcess(urlParams, sessionZone) {
  const urlParamsSelection = getUrlParamsSelection(urlParams, sessionZone);
  if (urlParamsSelection.ids || urlParamsSelection.productOfferings) {
    yield put(modulesActions.selectModulesUrl({ urlParamsSelection, directBuyProcess: urlParams?.directBuyProcess }));
  } else {
    yield put(uiActions.setBouncingLogo(false));
  }
}

function* handleSendRetentionPromo(urlParams) {
  let promotions = null;

  if (Array.isArray(urlParams.sendRetentionPromo) && urlParams.sendRetentionPromo.length > 0) {
    promotions = urlParams.sendRetentionPromo;
  } else {
    promotions = safeParseSessionStorage('retentionPromotions');
  }
  if (promotions) {
    yield put(
      uiActions.setConfirmation({ status: CONFIRMATION_STATUS.LOADING }),
    );
    yield call(sendRetentionPromo, { promotions });
  }
}

function* handleBackOfficeSend() {
  
  let backOfficeInfo = safeParseSessionStorage('backOfficeSend')

  if (backOfficeInfo) {
    yield put(
      uiActions.setConfirmation({ status: CONFIRMATION_STATUS.LOADING }),
    );
    yield call(sendOrder2BackOffice, backOfficeInfo);
  }
}

function* handleSendCapa() {
      if(
        typeof window !== "undefined"
        && typeof sessionStorage !== "undefined"
        && safeParseSessionStorage('modulosToApply')) {
          const modulosToApply = safeParseSessionStorage('modulosToApply');
          if(modulosToApply) {
            yield call(handleSessionStorageParamSelection, modulosToApply);
          }
      }
      let capa =  safeParseSessionStorage('capaInfo');
      if (capa) {
        yield call(navigate2PurchaseProcess, { purchaseProcess: capa });
      }
      
}

function* handleConfirmation(urlParams) {
  
  let confirmationInfo = safeParseSessionStorage('capaInfo')
  sessionStorage.removeItem('capaInfo');

  const status = confirmationInfo ? CONFIRMATION_STATUS.OK : CONFIRMATION_STATUS.KO;
  yield put(uiActions.setConfirmation({
    type: urlParams.confirmation,
    status,
    info: confirmationInfo?.states[status],
  }));
}

function* handleRetentionModules(urlParams) {
  yield put(clientActions.getRetention(urlParams.retentionModules));
}

function* handleUrlParamsSelection(urlParams,sessionZone) {
  const urlParamsSelection = getUrlParamsSelection(urlParams, sessionZone);
  
  if (urlParamsSelection.ids || urlParamsSelection.productOfferings) {
    yield put(modulesActions.selectModulesUrl({ urlParamsSelection }));
  }
}

function* handleOpenLmModal() {
  const ui = yield select(uiStore);
  const screenType = ui.screenType;
  yield put(
    modalActions.addModal({
      id: 'MobileLinesModal',
      Element2Show: MobilesLinesModal,
      modalProps: {
        closeByClickingOutside: true,
        contentPosition:
          screenType === SCREEN_TYPES.MOBILE
            ? 'bottom--center'
            : 'center--center',
        inSceneEffect: 'fadeInBottom',
        outSceneEffect: 'fadeOutBottom',
        opacityLayoutColor: 'blur',
        scrollAllowed: false,
        taggingInfoWhenClickingOutside: {
          componentName: 'mobileLinesModal',
          componentContent: 'cerrar',
        },
        ...mobileLinesModalNavigationProps,
      },
      elementProps: {
        screenType,
      },
    })
  );
}

function* handleSessionStorageParamSelection(modulosToApply) {
  const modulosCopy = modulosToApply;
  if(sessionStorage && sessionStorage.getItem('modulosToApply')){
    sessionStorage.removeItem("modulosToApply");
  }
  const urlParamsSelection = getUrlParamsSelection({modulos: modulosCopy}, FREE_ZONE_ID);
  yield put(modulesActions.selectModulesUrl({ urlParamsSelection }));
}

export function* initModules({
  build,
  client,
  sessionZone,
  urlParams,
}) {
  const main = yield select(mainStore);
  const modulos = yield select(modulosStore);
  const {
    context,
    userBundle,
    userPo,
    userPromotions,
    userCompatibilities,
    customer,
    userPq,
    zone,
  } = main;
  const frontSonda = new FrontSonda({
    processName: 'initModules',
    context,
    filePath,
  });
  const { statusModulos } = modulos;

  let data = null;
  if (client || statusModulos !== API_STATUS.OK) {
    try {
      // PONEMOS ESTADO A MODO CARGNAOD
      yield* setLoadingState();
      data = yield call(configInit, {
        context,
        build,
        urlParams,
        mainInfo: {
          userBundle,
          userPo,
          userPromotions,
          userCompatibilities,
          customer,
          userPq,
          zone,
        },
      });
      if (!data?.modulos) {
        console.log('log data', data)
        throw new ReferenceError(`initCatch error ${data?.error} `);
      }
      yield* setSuccessState(data, client);
    } catch (error) {
      console.log('log error', error)
      yield* reportInitError(error, data, build, frontSonda, client);
    }
  }
  yield call(setMinorLmPrice, {modulos: data?.modulos?.conectividad?.lme?.items});
  if (urlParams) {
    const urlHandlers = {
      directBuyProcess: handleDirectToBuyProcess,
      sendRetentionPromo: handleSendRetentionPromo,
      backOfficeSend: handleBackOfficeSend,
      sendCapa: handleSendCapa,
      confirmation: handleConfirmation,
      retentionModules: handleRetentionModules,
      openLmModal: handleOpenLmModal,
    };
    
    for (const key of Object.keys(urlHandlers)) {
      if (urlParams[key]) {
        yield* urlHandlers[key](urlParams, sessionZone);
        return; // salimos tras el primero que aplique
      }
    }
    yield* handleUrlParamsSelection(urlParams, sessionZone);
   
  } 
}

export function* selectModules({ ids, urlParamsSelection, directBuyProcess }) {
  const cloudTraceServiceSelect = new CloudTraceService('front/selectConfig');
  cloudTraceServiceSelect.startSpan()
  yield put(modulesActions.setStatusSelection(API_STATUS.LOADING));

  const main = yield select(mainStore);
  const client = yield select(clientStore);
  const cart = yield select(cartStore);
  const multibundleOldOptions = yield select(multibundleOldOptionsStore);
  const ui = yield select(uiStore);

  const {
    context,
    zone,
  } = main || {};
  const {
    items: selectedIds,
  } = cart?.modulos || {};
  const {
    bundleId,
    modulos,
    tv,
    mobile,
    netflix,
    productZoneId,
    mirrorFusionModules,
    productType,
    promotions,
    pocas,
    speedId,
  } = client || {};

  const { layout } = ui || {};
  const frontSonda = new FrontSonda({
    processName: 'selectModules',
    context,
    filePath,
  });

  const sessionZone = productZoneId || zone;
  let clientInfo = null;

  if (bundleId) {
    clientInfo = {
      bundleId,
      modulos,
      tv,
      mobile,
      netflix,
      mirrorFusionModules,
      productType,
      promotions,
      pocas,
      speedId,
    };
  }
  let idskeys = [];
  let oldOptions = {};
  let newOptions = {};

  const idsOnlyId = ids && Array.isArray(ids) && ids.map(({ id }) => id);
  if (
    idsOnlyId
    && Array.isArray(idsOnlyId)
    && idsOnlyId.length > 0
    && idsOnlyId[0].startsWith('9940')
  ) {
    idskeys = idsOnlyId && parseArrayToDict(idsOnlyId);
    if (isObject(idskeys)) {
      yield put(modulesActions.setmultibundleOldOptions({ ...idskeys }));
    }
  }
  if (isObject(multibundleOldOptions)) {
    oldOptions = { ...multibundleOldOptions };
  }
  if (!isEmpty(idskeys)) {
    newOptions = { ...oldOptions, ...idskeys };
  }
  const oldMultibundleOptions = flattenObjectToKeyValueStrings({ ...oldOptions, ...newOptions });
  const urlParams = getUrlParams();

  let data = null;
  let selectionError = null;
  try {
    data = yield call(selection, {
      context,
      clientInfo,
      ids,
      urlParamsSelection,
      selectedIds,
      sessionZone,
      oldMultibundleOptions,
      urlParams,
    });
  } catch (error) {
    selectionError = error;
    if (
      error
      && [422,458,499].includes(error.statusCode)
      && error.data
    ) {
      // Error controlado
      data = JSON.parse(error.data);
      console.error(error);
      frontSonda.warningMessage({
        info: `Error en SelectModules: ${error.error}`,
      });
    } else {
      console.error(error);
      frontSonda.errorMessage({
        error: `Fallo en selectModules ${error?.error || JSON.stringify(error)}`,
        info: 'Fallo en servicio selection',
      });
    }
  }

  if (data && data.modulos && data.cart) {
    yield put(modulesActions.setStatusSelection(API_STATUS.OK));
    yield put(modulesActions.setModules(data.modulos));
    yield put(uiActions.getPermanence(data.cart?.modulos?.conectividad?.items));
    yield put(cartActions.setCart(data.cart));
        // mirar layout 

    if(layout === LAYOUT_TYPES.CONECTIVIDAD && data?.autoSelection?.conectivityLayoutAdviceText) {
      if (data?.autoSelection?.conectivityLayoutAdviceText) {
        yield put(uiActions.setConfigLayoutRequiement(data?.autoSelection?.conectivityLayoutAdviceText));
      }
    } else {
    if (data.autoSelection) {
        yield put(uiActions.setNotification(data.autoSelection.autoSelectedText));
      }
      if (
        data.incompatibility
          && Object.keys(data.incompatibility).length > 0
      ) {
        yield put(uiActions.setNotification(data.incompatibility?.incompabilityText));
      }
    }
    

    if (Array.isArray(data.cart?.modulos?.items)) {
      let tipoR2r = getR2rTypeByApi(main?.userPq?.clt);
      const isUserClient = !!main?.userPq?.clt;
      const hasR2rIncHired = main?.userCompatibilities?.r2r?.hiredR2R.length > 0;
      const isUserBase = clientInfo?.modulos?.some(
        (eachModule) => eachModule.id.includes(CONECTIVIDAD_BASE_ID))
      const isUserEsential = clientInfo?.modulos?.some(
        (eachModule) => eachModule.id.includes(CONECTIVIDAD_ESENCIAL))
      const isBaseSelected = data.cart?.modulos?.items?.some(
        (eachModule) => eachModule.id.includes(CONECTIVIDAD_BASE_ID))
      const isEsentialSelected = data.cart?.modulos?.items?.some(
        (eachModule) => eachModule.id.includes(CONECTIVIDAD_ESENCIAL))
      const isFutbolOrFiccionSelected = data.cart?.modulos?.items?.some(
        (eachModule) => BASE_R2R_UPGRADES.includes(eachModule.id));
      
        if(isUserClient) {
          if(isUserBase ) {
            if(!hasR2rIncHired) {
              if(isFutbolOrFiccionSelected) {
                tipoR2r = TIPOS_R2R.INCLUIDO;
              } else{
                tipoR2r = TIPOS_R2R.ADICIONAL;
              }
            } else {
              tipoR2r = TIPOS_R2R.ADICIONAL;
            }
          } else if(isUserEsential) {
            if(!hasR2rIncHired && !isBaseSelected) {
              tipoR2r = TIPOS_R2R.INCLUIDO;
            } else {
              tipoR2r = TIPOS_R2R.ADICIONAL;
            }
          }
        } else {
          if(isBaseSelected) {
            if(isFutbolOrFiccionSelected) {
              tipoR2r = TIPOS_R2R.INCLUIDO;
            } else {
              tipoR2r = TIPOS_R2R.ADICIONAL;
            }
          } else if(isEsentialSelected) {
            tipoR2r = TIPOS_R2R.ADICIONAL;
          }
        }




      // if (isUserClient) {
      //   if (
      //     isUserBaseOrEsential
      //       && (!hasR2rIncHired && !isSelectedBaseOrEsential)
      //   ) {
      //     tipoR2r = TIPOS_R2R.INCLUIDO;
      //   } else {
      //     tipoR2r = TIPOS_R2R.ADICIONAL;
      //   }
      // } else {
      //   // No cliente
      //   tipoR2r = isSelectedBaseOrEsential
      //     ? TIPOS_R2R.ADICIONAL
      //     : TIPOS_R2R.INCLUIDO;
      // }

      yield put(clientActions.setR2rType(tipoR2r));
      if(!clientInfo || clientInfo?.productType !== PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID) {
        yield put(uiActions.setBouncingLogo(false))
      } else {
        if(directBuyProcess) {
          yield put(cartActions.purchase())
        }
      }
      
    }
  cloudTraceServiceSelect.endSpan()
  } else {
    yield put(
      uiActions.setTapon({
        ...getTaponInfo(clientInfo, selectionError?.statusCode || '500'),
        componentContent: 'Fallo en el servicio selection',
      }),
    );
    yield put(modulesActions.setStatusSelection(API_STATUS.KO));
     cloudTraceServiceSelect.endSpanWithError('Fallo en el servicio selection')
  }
}
